// extracted by mini-css-extract-plugin
export var container = "area-breadcrums-row-module--container--1tXBg";
export var breadcrums = "area-breadcrums-row-module--breadcrums--PM4-H";
export var link = "area-breadcrums-row-module--link--3Svyu";
export var rightIcon = "area-breadcrums-row-module--rightIcon--34619";
export var areaSelectionButton = "area-breadcrums-row-module--areaSelectionButton--J8WJZ";